// extracted by mini-css-extract-plugin
export default {"fixedContainer":"FixedCloseButton_fixedContainer__DSKZv","hidden":"FixedCloseButton_hidden__DaR4z","visible":"FixedCloseButton_visible__BMXCe"};